import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { SisinService } from '../../../services/formulacion/sisin.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
declare var toastr;

@Component({
  selector: 'app-sisin',
  templateUrl: './sisin.component.html',
  styles: []
})
export class SisinComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataResourcePR: any[];
  model: any = {
    id: 0,
    codigo: '',
    descripcion: '',
    activo: true
  };
  codSisinId: number;
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  state_toogle: boolean = false;
  vigencia: any[];
  baseUrl = environment.apiEndpoint;
  hasError: any;

  constructor(private _ss: SisinService) {
    this.vigencia = [{ text: 'Activo', value: true }, { text: 'Inactivo', value: false }];
    this.clearErrors();
    this.getSisins();
  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { codigo: false, descripcion: false };
  }

  getSisins() {
    this._ss.getSisin().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourcePR = result.data;
        } else {
          this.dataResourcePR = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    this.model.codigo = '';
    this.model.descripcion = '';
    this.model.activo = true;
    this.state_toogle = false;
    this.popupVisibleAdd = true;
  }

  showModalEdit(data: any) {
    this.clearErrors();
    this.model.id = data.id;
    this.model.codigo = data.codigo;
    this.model.descripcion = data.descripcion;
    this.model.activo = data.activo;
    this.state_toogle = true;
    this.popupVisibleAdd = true;
  }

  saveSisin() {
    this.hasError = { codigo: false, descripcion: false };
    if (this.validate(this.model)) {
      if (this.model.id == 0) {
        this._ss.postSisin(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getSisins();
              this.popupVisibleAdd = false;
              toastr.success('Sisin adicionado exitosamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
      else {
        this._ss.putSisin(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getSisins();
              this.popupVisibleAdd = false;
              toastr.success('Sisin modificado exitosamente.');
            } else {
              toastr.warning(result.data);
            }
          },
          error => { console.log('Error', error); });
      }
    }
  }

  showModalDelete(id: number) {
    this.codSisinId = id;
    this.popupVisibleDel = true;
  }

  deleteSisin() {
    this._ss.deleteSisin(this.codSisinId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getSisins();
          this.popupVisibleDel = false;          
          toastr.success('Proceso realizado correctamente.');          
        } else {           
          this.getSisins();   
          this.popupVisibleDel = false;          
          toastr.warning(result.data);   
        }
      },
      error => { console.log('Error', error); });
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.codigo, 'text')) {
      this.hasError.codigo = true; res = false;
    }
    if (!UtilHelper.validator(data.descripcion, 'text')) {
      this.hasError.descripcion = true; res = false;
    }
    return res;
  }
}
